import { ColumnsType } from "antd/es/table";

import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";
import { Tag, Tooltip } from "antd";
import { message } from "antd";


import { Space, Dropdown, Popover, Select, Button, Divider } from "antd";
import { useState } from "react";
import { setEtiquetasPessoaService } from "../../../services/setEtiquetasPessoaService";

type EtiquetaOption = { id: number; nome: string; cor?: string | null };

export const Columns = (
   onClick: (e: any) => void,
  setLeadId: (id: number | null) => void,
  filteredInfo: {
    nome?: string[] | null;
    celular?: string[] | null;
    status?: string[] | null;
    etiquetas?: string[] | null;
    observacoes?: string[] | null;
    tipo?: string[] | null;
  },
  etiquetasOptions: EtiquetaOption[],
  setPessoas: React.Dispatch<React.SetStateAction<any[]>>,
  setPessoaId: React.Dispatch<React.SetStateAction<number | null>>,
  setRowAtual?: (row: any) => void
): ColumnsType<any> => {
 

  const EditarEtiquetasPopover = ({
  pessoaId,
  currentEtiquetas,
  etiquetasOptions,
  setPessoas,
  children,
}: any) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<number[]>(
    (currentEtiquetas ?? []).map((e: any) => e.id)
  );
  const [saving, setSaving] = useState(false);

  const options = (etiquetasOptions ?? []).map((e: any) => ({
    label: e.nome,
    value: e.id,
  }));

  const salvar = async () => {
    setSaving(true);
    const resp = await setEtiquetasPessoaService(pessoaId, value);
    setSaving(false);

    if (!resp || !resp.etiquetas) return;

    // atualiza a linha com o retorno do backend (fonte da verdade)
    setPessoas((prev: any[]) =>
      prev.map((p) =>
        p.pessoaId === pessoaId ? { ...p, etiquetas: resp.etiquetas } : p
      )
    );

    setOpen(false);
  };

  return (
    <Popover
      open={open}
      onOpenChange={(v) => {
        setOpen(v);
        if (v) {
          setValue((currentEtiquetas ?? []).map((e: any) => e.id)); // reseta ao abrir
        }
      }}
      trigger="click"
      title="Editar etiquetas"
      content={
        <div style={{ width: 320 }}>
          <Select
            mode="multiple"
            showSearch
            style={{ width: "100%" }}
            placeholder="Selecione etiquetas..."
            value={value}
            onChange={setValue}
            options={options}
            optionFilterProp="label"
          />

          <Divider style={{ margin: "10px 0" }} />

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button onClick={() => setValue([])}>Limpar</Button>
            <Button type="primary" loading={saving} onClick={salvar}>
              Salvar
            </Button>
          </div>
        </div>
      }
    >
      <span style={{ cursor: "pointer" }}>{children}</span>
    </Popover>
  );
};





  return [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",
      width: "30%",
      filteredValue: filteredInfo.nome || null, // Aplicar os valores do estado
      onFilter: (value, record) => {
  const field = record?.nome;
  if (field == null) return false; // ignora null e undefined
  return String(field).toLowerCase().includes(String(value).toLowerCase());
},
      ...ColumnSearch<any>({ dataIndex: "nome" }),
    },
    {
      title: "Telefone",
      dataIndex: "celular",
      key: "celular",
      width: "30%",
      filteredValue: filteredInfo.celular || null, // Aplicar os valores do estado
      onFilter: (value, record) => {
  const field = record?.celular;
  if (field == null) return false; // ignora null e undefined
  return String(field).toLowerCase().includes(String(value).toLowerCase());
},
      ...ColumnSearch<any>({ dataIndex: "celular" }),
    },
   
    
 {
  title: "Etiquetas",
  dataIndex: "etiquetas",
  key: "etiquetas",
  width: "20%",
  filters: (etiquetasOptions ?? []).map((e) => ({ text: e.nome, value: e.nome })),
  filteredValue: filteredInfo.etiquetas || null,
  onFilter: (value, record) => {
    const etiquetas = record?.etiquetas ?? [];
    return etiquetas.some((e: any) =>
      String(e.nome ?? "").toLowerCase().includes(String(value).toLowerCase())
    );
  },
  filterSearch: true,

  render: (_: any, row: any) => {
  const etiquetas = row.etiquetas ?? [];

  const clickableTarget =
    etiquetas.length === 0 ? (
      <Tag style={{ cursor: "pointer" }}>+ Etiqueta</Tag>
    ) : (
      <Space size={6} wrap>
        {etiquetas.slice(0, 4).map((e: any) => (
          <Tooltip key={e.id} title={e.nome}>
            <span
              style={{
                width: 12,
                height: 12,
                borderRadius: 999,
                display: "inline-block",
                backgroundColor: e.cor || "#1677ff",
                border: "1px solid rgba(0,0,0,0.12)",
              }}
            />
          </Tooltip>
        ))}

        {etiquetas.length > 4 && (
          <Tooltip
            title={
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, maxWidth: 280 }}>
                {etiquetas.slice(4).map((e: any) => (
                  <span key={e.id} style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
                    <span
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: 999,
                        backgroundColor: e.cor || "#1677ff",
                        border: "1px solid rgba(0,0,0,0.12)",
                        display: "inline-block",
                      }}
                    />
                    <span>{e.nome}</span>
                  </span>
                ))}
              </div>
            }
          >
            <span
              style={{
                fontSize: 12,
                padding: "0 6px",
                border: "1px solid rgba(0,0,0,0.12)",
                borderRadius: 10,
                cursor: "pointer",
              }}
            >
              +{etiquetas.length - 4}
            </span>
          </Tooltip>
        )}
      </Space>
    );

  return (
    <EditarEtiquetasPopover
      pessoaId={row.pessoaId}
      currentEtiquetas={etiquetas}
      etiquetasOptions={etiquetasOptions}
      setPessoas={setPessoas}
    >
      {clickableTarget}
    </EditarEtiquetasPopover>
  );
},

},




    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "30%",
      filters: [
        { text: "Andamento", value: "Andamento" },
        { text: "Convertido", value: "Convertido" },
        { text: "Divulgar", value: "Divulgar" },
        { text: "Sem interesse", value: "Sem interesse" },
      ],
      filteredValue: filteredInfo.status || null,
           onFilter: (value, record) => {
  const field = record?.status;
  if (field == null) return false; // ignora null e undefined
  return String(field).toLowerCase().includes(String(value).toLowerCase());
},
      filterSearch: true,
    },
    {
      title: "Observações",
      dataIndex: "observacoes",
      key: "observacoes",
      width: "30%",
      filteredValue: filteredInfo.observacoes || null,
           onFilter: (value, record) => {
  const field = record?.observacoes;
  if (field == null) return false; // ignora null e undefined
  return String(field).toLowerCase().includes(String(value).toLowerCase());
},
      filterSearch: true,
    },
    {
      title: "Tipo",
      dataIndex: "tipo",
      key: "tipo",
      width: "30%",
      filters: [
        { text: "Lead", value: "Lead" },
        { text: "Revendedor", value: "Revendedor" },
        { text: "Proprietario", value: "Proprietario" },
        { text: "Golpista", value: "Golpista" },
        { text: "Indicação jurídico", value: "Indicação jurídico" },
      ],
      filteredValue: filteredInfo.tipo || null,
           onFilter: (value, record) => {
  const field = record?.tipo;
  if (field == null) return false; // ignora null e undefined
  return String(field).toLowerCase().includes(String(value).toLowerCase());
},
      filterSearch: true,
    },

   {
  title: "Ações",
  dataIndex: "operation",
  key: "operation",
  width: "10%",
  align: "center",
  render: (_: any, row: any) => {
    const isLead = row.origem === "LEAD" && !!row.leadId;

    const handleClick = ({ key }: any) => {
      if (!isLead) {
        message.warning("Não é possível editar/excluir usuários por aqui.");
        return;
      }

      // garante que o leadId correto vai pros modais
      setLeadId(row.leadId);
      setPessoaId(row.pessoaId ?? null);
   

      // agora executa a ação do menu normal
      onClick({ key });
    };

    // se você quiser desabilitar visualmente os itens também:
    const items = getMenuItems(isLead); // (ver passo 3)

    return (
      <Space size="middle">
        <Dropdown menu={{ items, onClick: handleClick }} trigger={["click"]}>
          <BotoesAcoes>
            <Space>
              <SettingsIcon />
            </Space>
          </BotoesAcoes>
        </Dropdown>
      </Space>
    );
  },
}

  ];
};
